module.exports = __webpack_public_path__ + "img/20.b7b2e011.png";